import { c as _c } from "react/compiler-runtime";
import { useAnalytics } from '@repo/analytics/analytics-provider';
import { toast } from '@repo/design-system/components/ui/toaster';
import { useHostType } from '@repo/host/hooks/use-host-info';
import { useT } from '@repo/i18n/components/i18n.client';
import { createPublicMapUrl } from '@repo/types/maps/map-utils';
import { copyTextToClipboard } from '@repo/utility/clipboard';
import { buildRedditShareUrl, buildTwitterShareUrl } from '@repo/utility/social-share';
import { openSharePopup } from './open-share-popup';
interface UseMapShareHandlersParams {
  mapName: string;
  gameTitle: string;
  titleSlug: string;
  mapSlug: string;
  shareUrl?: string;
  resolveShareUrl?: () => string | Promise<string>;
}
export function useMapShareHandlers(t0) {
  const $ = _c(31);
  const {
    mapName,
    gameTitle,
    titleSlug,
    mapSlug,
    shareUrl,
    resolveShareUrl
  } = t0;
  const analytics = useAnalytics();
  const hostType = useHostType();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  let t2;
  if ($[1] !== mapSlug || $[2] !== resolveShareUrl || $[3] !== shareUrl || $[4] !== titleSlug) {
    t2 = async () => {
      const resolvedShareUrl = resolveShareUrl ? await resolveShareUrl() : shareUrl;
      return resolvedShareUrl || createPublicMapUrl({
        titleSlug,
        mapSlug
      });
    };
    $[1] = mapSlug;
    $[2] = resolveShareUrl;
    $[3] = shareUrl;
    $[4] = titleSlug;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const getUrlToShare = t2;
  let t3;
  if ($[6] !== analytics || $[7] !== gameTitle || $[8] !== getUrlToShare || $[9] !== hostType || $[10] !== mapName || $[11] !== t) {
    t3 = async () => {
      const redditShareContent = t(_temp, {
        mapName,
        titleName: gameTitle
      });
      await openSharePopup(getUrlToShare, urlToShare => buildRedditShareUrl(urlToShare, redditShareContent));
      analytics?.event("game_map_details_reddit_share_click", {
        mapName: mapName || "",
        titleName: gameTitle || "",
        platform: hostType || ""
      });
    };
    $[6] = analytics;
    $[7] = gameTitle;
    $[8] = getUrlToShare;
    $[9] = hostType;
    $[10] = mapName;
    $[11] = t;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const handleRedditShareClick = t3;
  let t4;
  if ($[13] !== analytics || $[14] !== gameTitle || $[15] !== getUrlToShare || $[16] !== hostType || $[17] !== mapName || $[18] !== t) {
    t4 = async () => {
      const urlToShare_0 = await getUrlToShare();
      const discordShareContent = t(_temp2, {
        mapName,
        titleName: gameTitle,
        url: ""
      });
      const result = await copyTextToClipboard(`${discordShareContent} ${urlToShare_0}`);
      if (result.success) {
        toast({
          description: t(_temp3)
        });
        setTimeout(_temp4, 2500);
        analytics?.event("game_map_details_discord_share_click", {
          mapName: mapName || "",
          titleName: gameTitle || "",
          platform: hostType || ""
        });
      } else {
        toast({
          description: t(_temp5),
          variant: "error"
        });
      }
    };
    $[13] = analytics;
    $[14] = gameTitle;
    $[15] = getUrlToShare;
    $[16] = hostType;
    $[17] = mapName;
    $[18] = t;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  const handleDiscordShareClick = t4;
  let t5;
  if ($[20] !== analytics || $[21] !== gameTitle || $[22] !== getUrlToShare || $[23] !== hostType || $[24] !== mapName || $[25] !== t) {
    t5 = async () => {
      const twitterShareContent = t(_temp6, {
        mapName,
        titleName: gameTitle
      });
      await openSharePopup(getUrlToShare, urlToShare_1 => buildTwitterShareUrl(urlToShare_1, twitterShareContent));
      analytics?.event("game_map_details_twitter_share_click", {
        mapName: mapName || "",
        titleName: gameTitle || "",
        platform: hostType || ""
      });
    };
    $[20] = analytics;
    $[21] = gameTitle;
    $[22] = getUrlToShare;
    $[23] = hostType;
    $[24] = mapName;
    $[25] = t;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  const handleShareXClick = t5;
  let t6;
  if ($[27] !== handleDiscordShareClick || $[28] !== handleRedditShareClick || $[29] !== handleShareXClick) {
    t6 = {
      handleRedditShareClick,
      handleDiscordShareClick,
      handleShareXClick
    };
    $[27] = handleDiscordShareClick;
    $[28] = handleRedditShareClick;
    $[29] = handleShareXClick;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  return t6;
}
function _temp6($_3) {
  return $_3.game_map_details.twitter_share_content_wand;
}
function _temp5($_2) {
  return $_2.share_map_modal.share_link_copy_error;
}
function _temp4() {
  window.open("https://discord.com/channels/@me", "_blank");
}
function _temp3($_1) {
  return $_1.game_map_details.discord_share_content_toast;
}
function _temp2($_0) {
  return $_0.game_map_details.discord_share_content_wand;
}
function _temp($) {
  return $.game_map_details.reddit_share_content_wand;
}